import { FreeSpinsInfoEvent } from '@cgs/data-access';
import { BaseReelsSlotGame, SlotGameBuilder, SlotParams } from '@cgs/machines';
import {
  ApplicationGameConfig,
  ApplicationUserConfig,
  EnvironmentConfig,
  Logger,
} from '@cgs/shared';
import {
  initLaunchParams,
  TRIFECTA_LAUNCH_PARAMS_TOKEN,
  TrifectaLaunchParamsDto,
  mountRoundInfoFrame,
} from '@cgs/provider-trifecta';
import { Container, InstanceLifetime, PlatformSettings, Preloader, ResizeMode } from '@cgs/wge';
import packageJson from '../package.json';
import '../styles/main.css';
import { corsicaGameSettings } from './corsica-game-settings';
import { CorsicaGameProviderTrifecta } from './corsica-game-provider-trifecta';

function initAppSettings(): TrifectaLaunchParamsDto {
  const launchParams = window.launchParams as TrifectaLaunchParamsDto;

  if (!launchParams) {
    throw new Error('launchParams are missing');
  }

  console.log('launchParams', launchParams);

  if (launchParams.replayData !== undefined) {
    initLaunchParams(launchParams, 40);
  }

  const game = launchParams.game || launchParams.gameId || 'corsica';

  const gameId = launchParams.game.charAt(0).toUpperCase() + game.slice(1);

  ApplicationGameConfig.init({
    currency: launchParams.currencyId,
    gameId: gameId,
    machineId: `${launchParams.initData.machineState?.machineId || 5}`,
    appVersion: packageJson.version,
  });

  EnvironmentConfig.init({
    api: {
      url: '',
    },
  });

  ApplicationUserConfig.init({
    session: launchParams.gameSession,
    cheatUser: launchParams.initData.isCheatUser,
    userId: '',
    language: launchParams.languageId,
  });

  if (launchParams.resumeData !== undefined) {
    launchParams.isRecovery =
      launchParams.resumeData.spins.length !== 1 &&
      launchParams.resumeData.spins[0].freeSpinsInfo?.event !==
        FreeSpinsInfoEvent.FreeSpinsFinished;
  }

  launchParams.rtp = launchParams.rtp === 99.99 ? 96.33 : launchParams.rtp;

  return launchParams;
}

window.onload = () => {
  const canvas = document.getElementById('app-canvas') as HTMLCanvasElement;

  if (!canvas) {
    throw new Error('Cannot find root canvas element!');
  }

  Logger.Initialize();
  Logger.Debug('Logger initialized');

  const settings = new PlatformSettings(false, false, false, ResizeMode.ProportionalScale);
  settings.preloader = new Preloader(canvas, '#splashContainer');

  const launchParams = initAppSettings();

  console.log('[round-info] replayData:', launchParams.replayData);

  if (launchParams.replayData?.type === 'static') {
    console.log('[round-info] mounting round-info iframe');
    mountRoundInfoFrame({
      gameId: 'Corsica',
      currencyId: launchParams.currencyId,
      currencyDecimals: launchParams.currencyDecimals,
      symbolsPath: 'staticReplay/symbols',
      replayData: launchParams.replayData,
      operatorId: (launchParams as any).operatorId,
    });
    return;
  }

  const container = new Container();

  launchParams.buyFeatureMultiplier = 80;
  launchParams.buyBonusRtp = 96.5;
  launchParams.hitRate = 25.3;
  launchParams.volatility = '5/5';

  container.registerValue(TRIFECTA_LAUNCH_PARAMS_TOKEN, launchParams, {
    lifetime: InstanceLifetime.Singleton,
  });

  const gameProvider = new CorsicaGameProviderTrifecta(container);

  const slotParams = new SlotParams(ApplicationGameConfig.machineId, 5, 4, []);
  new SlotGameBuilder(
    window,
    canvas,
    settings,
    corsicaGameSettings,
    container,
    () => new BaseReelsSlotGame(container, slotParams),
    gameProvider
  ).build();
};
